export default "/kiban/_next/static/images/copperThickness-ef390619810cceb78b7dc8488bf3d395.png";